module.exports = __webpack_public_path__ + "img/DSC_1982.72161cc1.JPG";